import { render, staticRenderFns } from "./AutoSuggestAjax.vue?vue&type=template&id=f35436de&scoped=true&"
import script from "./AutoSuggestAjax.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestAjax.vue?vue&type=script&lang=js&"
import style0 from "./AutoSuggestAjax.vue?vue&type=style&index=0&id=f35436de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35436de",
  null
  
)

export default component.exports